import React from "react";

class Entry extends React.Component {
  constructor(props) {
    super(props);
  }

  getMentionEntryRenderData = (mention) => {
    switch (mention.type) {
      case "User":
        return {
          color: "#e1efff"          
        };
      case "Product":
        return {
          color: "#ffe6eb"
        };
      case "Group":
        return {
          color: "#ffffc1"
        };
    }
  };

  render() {
    const {
        mention,
        theme,
        searchValue,
        isFocused,
        ...parentProps
      } = this.props;

      const { color } = this.getMentionEntryRenderData(mention);

    return (
      <div {...parentProps}>
        <div className={theme?.mentionSuggestionsEntryContainer}>
          <div className={theme?.mentionSuggestionsEntryContainerLeft}>
            <img
              src={`https://go5050uk.blob.core.windows.net/go5050images/${mention.imageId}`}
              className={theme?.mentionSuggestionsEntryAvatar}
              role="presentation"
            />
          </div>

          <div className={theme?.mentionSuggestionsEntryContainerRight}>
            <div className={theme?.mentionSuggestionsEntryText}>
              {mention.name} <span style={{ background: color, fontSize: 'x-small', borderRadius: '4px', color: '#a7a7a7', padding: '0px 3px 0px 3px', marginLeft: '5px'}}>{mention.type}</span>
            </div>

            <div className={theme?.mentionSuggestionsEntryTitle}>
              {mention.description}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Entry;
